import { QualityRecordStatus } from '@/entities/Document';
import type { GeneratedRecordListItem, GeneratedRecordStatus } from '@/entities/GeneratedRecord';
import { RECORD_INDEXING_PLACEHOLDER } from '@/entities/Record';
import type { QualityRecordRow } from './quality-record-row.types';

const STATUS_BY_GENERATED_RECORD_STATUS: Record<GeneratedRecordStatus, QualityRecordStatus> = {
  AVAILABLE: QualityRecordStatus.DISPONIVEL,
  IN_USE: QualityRecordStatus.EM_USO,
  ARCHIVED: QualityRecordStatus.ARQUIVADO,
};

export function toQualityRecordRow(item: GeneratedRecordListItem): QualityRecordRow {
  // The column draws `prefix` and the "Registros gerados" search reads it, so it holds the record
  // title, which is unique in the branch. A blank name never reaches here, but the code still names
  // the row if one does.
  const isInspection = item.inspectionType !== null;
  return {
    id: item.id,
    prefix: item.name.trim() === '' ? item.code : item.name,
    name: item.name,
    indexing: (isInspection ? item.serialNumber : item.indexer) ?? RECORD_INDEXING_PLACEHOLDER,
    stageName: item.stage.name,
    status: STATUS_BY_GENERATED_RECORD_STATUS[item.status],
    filledBy: item.status === 'IN_USE' ? item.inUseByName : null,
    recordTypeName: item.recordTypeName,
    hasPdfResponse: item.hasPdfResponse,
  };
}
